import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import AccountBalanceWallet from "@material-ui/icons/es/AccountBalanceWallet";
import Add from "@material-ui/icons/es/Add";
import Remove from "@material-ui/icons/es/Remove";
import DeleteForever from "@material-ui/icons/es/DeleteForever";
import Button from "../../../components/material-pro/CustomButtons/Button";
import {injectStripe} from 'react-stripe-elements';
import {
    getCreditDetails,
    toggleCreditDetails,
    getPlans,
    getEmailPlans,
    attachPlanToClient,
    detachPlanFromClient,
    deletePlansFromClient,
    confirm3dSecure
} from "../BillingActions";


export class SubscribeModal extends Component {
    state = {
        stripe: null
    }

    componentDidMount() {
        this.props.getPlans();
        this.props.getEmailPlans();

    }

    componentWillReceiveProps(nextProps) {
        const {app, billing} = nextProps;

        if (!app.fetching && !billing.fetching && app.stripe.stripePublishableKey) {
            if (window.Stripe) {
                this.setState({stripe: window.Stripe(app.stripe.stripePublishableKey)})
            } else {
                const stripeScript = document.getElementById('stripeScript');
                stripeScript.addEventListener('load', () => {
                    this.setState({stripe: window.Stripe(app.stripe.stripePublishableKey)});
                });
            }
        }
    }

    handleRequireAction = async (subscription) => {
        const { requireActionInfo, stripeSubscriptionId: subId, email } = subscription;
        const {clientSecret, paymentMethodId} = requireActionInfo

        // You can also use confirmCardPayment with the PaymentIntents API automatic confirmation flow.
        // See our confirmCardPayment documentation for more:
        // https://stripe.com/docs/stripe-js/reference#stripe-confirm-card-payment
        this.props.stripe.confirmCardPayment(clientSecret, {
            payment_method: paymentMethodId,
        }).then((result) => {
            if (result.error) {
                // Start code flow to handle updating the payment details.
                // Display error message in your UI.
                // The card was declined (i.e. insufficient funds, card has expired, etc).
                throw result;
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    // Show a success message to your customer.
                    // There's a risk of the customer closing the window before the callback.
                    // We recommend setting up webhook endpoints later in this guide.
                    // TODO: update page
                    this.props.confirm3dSecure({ email, subId });
                    this.props.getEmailPlans();
                    this.setState({})
                }
            }
        })
            .catch((error) => {
                // console.error(`[CheckoutForm][handleSubmit]`,error)
                // TODO: Error
                // displayError(error);
            });
    };

    subscribeHandler = (planId) => {
        this.props.attachPlanToClient(planId)
    }

    unSubscribeHandler = (planId) => {
        this.props.detachPlanFromClient(planId)
    }

    cancelAllHandler = () => {
        this.props.deletePlansFromClient()
    }

    showOnScreen = () => {
        const {billing: {customer, plansContent, emailPlans}, env} = this.props;
        const plansObjects = [...plansContent];
        const emailPlansObjects = [...emailPlans];

        if (env === 'production') {
            return null
        }

        return (
            <div>
                <p>{customer.name} {customer.country} {customer.email}</p>
                {env === 'production' ? '' :
                    <Button onClick={() => this.cancelAllHandler()} color="info">
                        <DeleteForever/>
                        CANCEL ALL
                    </Button>
                }
                {
                    plansObjects.map((plan) => {
                        let emailPlan = emailPlansObjects.find(item => item.id === plan.id);
                        const subscription = emailPlan && emailPlan.emailSubscriptionsViewEntities && emailPlan.emailSubscriptionsViewEntities[0]
                        const isMarked = emailPlansObjects.some(item => item.id === plan.id);
                        return (
                            <div key={plan.id}
                                 style={{backgroundColor: isMarked ? subscription.subscriptionStatus === 1 ? 'green' : 'yellow' : 'initial'}}>
                                <p>{plan.name} {plan.id} Status: {subscription && subscription.subscriptionStatusText || 'not subscribed'} {subscription && ('    |   Cancel at period end = ' + subscription.cancelAtPeriodEnd + '  |   Valid until ' + new Date(subscription.validUntil).toISOString())} </p>
                                <Button
                                    disabled={!customer.last4Digits
                                    ||
                                    ((subscription && subscription.subscriptionStatus === 1) && subscription.cancelAtPeriodEnd === false)
                                    ||
                                    subscription && subscription.requireActionInfo}
                                    onClick={() => this.subscribeHandler(plan.id)} color="info">
                                    <Add/>
                                    {(subscription && subscription.cancelAtPeriodEnd) ? ' RESUME' : 'SUBSCRIBE'}
                                </Button>
                                <Button disabled={
                                    !subscription
                                    ||
                                    subscription.subscriptionStatus !== 1
                                    ||
                                    (subscription.subscriptionStatus === 1 && subscription.cancelAtPeriodEnd === true)
                                    ||
                                    !customer.last4Digits} onClick={() => this.unSubscribeHandler(plan.id)}
                                        color="info">
                                    <Remove/>
                                    UNSUBSCRIBE
                                </Button>
                                {customer.last4Digits && subscription && subscription.requireActionInfo ?
                                    <Button
                                        onClick={() => this.handleRequireAction(subscription)}
                                        color="info">
                                        <AccountBalanceWallet/>
                                        Authenticate
                                    </Button> : ''}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.showOnScreen()}
            </div>
        )
    }
}

const mapStateToProps = ({app, billing}) => ({app, billing});

const mapDispatchToProps = dispatch => bindActionCreators({
    getCreditDetails,
    toggleCreditDetails,
    getPlans,
    getEmailPlans,
    attachPlanToClient,
    detachPlanFromClient,
    deletePlansFromClient,
    confirm3dSecure
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(SubscribeModal))
// export default SubscribeModal



// WEBPACK FOOTER //
// ./src/containers/billing/components/SubscribeModal.js